import { useState, useEffect } from 'react';

// Free, no-auth hit counter (https://abacus.jasoncameron.dev).
// Each post's slug is its own counter key; the displayed number is
// the seeded baseline plus the real number of views since launch.
const NAMESPACE = 'jonahodoh-blog-v1';
const BASE = 'https://abacus.jasoncameron.dev';

export const useViews = (slug, baseline = 0) => {
  const [live, setLive] = useState(null);

  useEffect(() => {
    if (!slug) return undefined;
    let active = true;

    fetch(`${BASE}/hit/${NAMESPACE}/${encodeURIComponent(slug)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (active && data && typeof data.value === 'number') {
          setLive(data.value);
        }
      })
      .catch(() => {
        /* offline or API down — fall back to the baseline */
      });

    return () => {
      active = false;
    };
  }, [slug]);

  // Show the baseline immediately; bump to baseline + real hits once it loads.
  return baseline + (live ?? 0);
};
